import { ScopeProvider } from 'jotai-scope';

// Atoms
import { datepickerAtom } from '@/components/base/Datepicker/DatepickerComponent/Atoms/datepickerAtom';
import { HydrateAtoms } from '@/components/base/Datepicker/DatepickerComponent/components/DatepickerWrapper/HydrateAtoms';
import { AtomsListener } from '@/components/base/Datepicker/DatepickerComponent/components/DatepickerWrapper/AtomsListener';

// Types
import type { HydrateDatepickerAtomsProps } from '@/components/base/Datepicker/DatepickerComponent/components/DatepickerWrapper/HydrateAtoms';

export type DatepickerWrapperProps = HydrateDatepickerAtomsProps;

export function DatepickerWrapper({ children, ...restProps }: DatepickerWrapperProps) {
    return (
        <ScopeProvider atoms={[datepickerAtom]}>
            <HydrateAtoms {...restProps}>
                <AtomsListener settings={restProps.settings}>{children}</AtomsListener>
            </HydrateAtoms>
        </ScopeProvider>
    );
}
